import React, { type FC } from "react";

import { Loader } from "../../../Loader";

import type { LoaderProps } from "../../../Loader";

const SWITCH_LOADER_TEST_ID = "switch-loader-test-id";

export type SwitchLoaderProps = Required<Pick<LoaderProps, "label">>;

export const SwitchLoader: FC<SwitchLoaderProps> = (props) => {
    return <Loader size="16" data-tsid={SWITCH_LOADER_TEST_ID} {...props} />;
};

SwitchLoader.displayName = "Switch.Loader";

export default SwitchLoader;
